import React, { useState } from 'react';
import { addToast } from './Notifications';
import './AddTransaction.css';

function AddTransaction({ onAdd, initialType }) {
  const [description, setDescription] = useState('');
  const [amount, setAmount] = useState('');
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [isExpense, setIsExpense] = useState(initialType ? initialType === 'expense' : true);

  const handleSubmit = () => {
    if (!date) { addToast('Date is required.', 'error'); return; }
    if (!description) { addToast('Description is required.', 'error'); return; }
    if (!amount) { addToast('Amount is required.', 'error'); return; }

    const raw = parseFloat(parseFloat(amount).toFixed(2));
    if (isNaN(raw) || raw <= 0) { addToast('Amount must be a positive number.', 'error'); return; }

    onAdd({
      description,
      amount: isExpense ? -Math.abs(raw) : Math.abs(raw),
      date: new Date(date).toISOString().split('T')[0],
    });

    setDescription('');
    setAmount('');
    setDate(new Date().toISOString().split('T')[0]);
    setIsExpense(initialType ? initialType === 'expense' : true);
  };

  return (
    <div className="add-card">
      <h4 className="add-card-title">New Transaction</h4>
      <div className="add-field">
        <label className="add-label">Type</label>
        <div className="add-toggle">
          <button
            type="button"
            className={`add-toggle-btn expense ${isExpense ? 'active' : ''}`}
            onClick={() => setIsExpense(true)}
          >
            − Expense
          </button>
          <button
            type="button"
            className={`add-toggle-btn income ${!isExpense ? 'active' : ''}`}
            onClick={() => setIsExpense(false)}
          >
            + Income
          </button>
        </div>
      </div>
      <div className="add-field">
        <label className="add-label">Date</label>
        <input
          type="date"
          className="add-input"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
      </div>
      <div className="add-field">
        <label className="add-label">Description</label>
        <input
          type="text"
          className="add-input"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="e.g. Grocery shopping"
        />
      </div>
      <div className="add-field">
        <label className="add-label">Amount ($)</label>
        <input
          type="number"
          step="0.01"
          min="0"
          inputMode="decimal"
          pattern="[0-9]*"
          className="add-input"
          value={amount}
          onChange={(e) => setAmount(e.target.value.replace(/[^0-9.]/g, ''))}
          onKeyDown={(e) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
          placeholder="0.00"
        />
      </div>
      <button
        type="button"
        className={`add-btn ${isExpense ? 'expense' : 'income'}`}
        onClick={handleSubmit}
      >
        Add {isExpense ? 'Expense' : 'Income'}
      </button>
    </div>
  );
}

export default AddTransaction;